<template>
    <div>
        战役管理
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>